<script lang="ts" setup>
import type { Category } from '~/models';

const props = defineProps<{
  subcategory: Category;
}>();
</script>

<template>
  <div class="border border-card bg-card rounded-md">
    <UAccordion
      :items="[{}]"
      :ui="{ item: { padding: '' } }"
    >
      <template #default="{ open }">
        <UButton
          class="
            w-full
            text-inherit
            focus-visible:ring-0
            min-h-16
            hover:bg-card
            px-4
            font-semibold
            bg-transparent
          "
          variant="ghost"
          :ui="{ rounded: 'rounded' }"
        >
          <div class="flex flex-col w-full items-start justify-center">
            <span
              class="text-base"
              data-test="name"
            >
              {{ props.subcategory.name }}
            </span>

            <span
              class="text-sm subtext-card"
              data-test="description"
            >
              {{ props.subcategory.description }}
            </span>
          </div>

          <template #trailing>
            <UIcon
              class="min-w-4 min-h-5 text-2xl text-gray-600 transform transition-transform duration-200"
              name="ic:round-keyboard-arrow-down"
              :class="[open && 'rotate-180']"
              data-test="expanded-icon"
            />
          </template>
        </UButton>
      </template>

      <template #item>
        <slot />
      </template>
    </UAccordion>
  </div>
</template>
